import React, {Component} from 'react';
import AccountExpenseContainer from '../../../containers/account_invoice_container';
import {Header, Tab} from 'semantic-ui-react';
import ExpenseEstimates from "./expense_estimate";
import ExpenseList from "./expenses";

class Expense extends Component {

    render() {
        const panes = [
            {menuItem: 'Pipeline Expenses', render: () => <Tab.Pane><ExpenseEstimates/></Tab.Pane>},
            {menuItem: 'Expenses ', render: () => <Tab.Pane><ExpenseList/></Tab.Pane>},
        ];

        return (<div style={{width: '95%', margin: 'auto'}}>
            <Header className="pad-top" content="Expenses" size="large" textAlign="left"/>
            <Tab panes={panes}/>
        </div>)
    }
}

export default AccountExpenseContainer(Expense);


// WEBPACK FOOTER //
// ./src/views/accounts/expense/index.js